import { all, put, takeEvery } from 'redux-saga/effects';

import { simpleRequestsLoader } from 'modules/app/utils';
import { createNotification } from 'modules/toast-notifications/actions';

import * as types from '../actionTypes';

/** @type {Record<string, import("modules/app/types").SimpleRequestConfig>} */
const simpleRequests = {
  [types.CREATE_REPORT_ISSUE_REQUEST]: {
    notifications: {
      success: () => undefined
    },
  },
};

function* onCreateTicketSuccess() {
  yield put(
    createNotification({
      type: 'success',
      message: {
        id: 'reportIssue.notifications.success.title',
        defaultMessage: 'Thank you!',
      },
      description: {
        id: 'reportIssue.notifications.success.description',
        defaultMessage: 'Request has been sent.',
      },
    })
  );
}

export default function* reportIssuesSagas() {
  yield all(simpleRequestsLoader(simpleRequests));
  yield takeEvery(types.CREATE_REPORT_ISSUE_SUCCESS, onCreateTicketSuccess);
}
